import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { FiX } from 'react-icons/fi';

import Seo from '../helpers/Seo';
import useDebounce from '../helpers/debounce';
import PageTitle from '../components/PageTitle';
import ProductListing from '../components/ProductListing';
import { Input as BaseInput } from '../components/Forms';

const Search = () => {
  const intl = useIntl();
  const history = useHistory();
  const inputEl = useRef(null);
  const [term, setTerm] = useState("");
  const debouncedSearchTerm = useDebounce(term, 500);

  useEffect(() => {
    inputEl.current.focus();
  });

  return (
    <>
      <Seo title={intl.formatMessage({ id: 'search.title' })} />
      <PageTitle>
        <InputWrapper>
          <Input
            ref={inputEl}
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            placeholder={intl.formatMessage({ id: 'search.input-placeholder' })} />
          <CloseButton onClick={() => history.goBack()}>
            <FiX />
          </CloseButton>
        </InputWrapper>
      </PageTitle>
      <ProductListing term={debouncedSearchTerm}></ProductListing>
    </>
  )
};

export default Search;

const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

const Input = styled(BaseInput).attrs({ type: 'search' })`
    letter-spacing: 2px;
    width: 25%;
    font-size: 80%;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: inherit;
`;